<template>
  <button
    class="burger"
    :class="modifiers"
    type="button"
    v-on="$listeners"
  >
    <span v-if="label" class="visually-hidden">{{ label }}</span>
    <svg viewBox="0 0 100 100" class="burger__svg">
      <path class="burger__line burger__line_one" d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058" />
      <path class="burger__line burger__line_two" d="M 20,50 H 80" />
      <path class="burger__line burger__line_three" d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942" />
    </svg>
  </button>
</template>

<script>
export default {
  name: 'BaseBurger',
  props: {
    label: {
      type: String,
      default: 'Показать меню',
    },
    isRound: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modifiers() {
      return {
        burger_active: this.isActive,
        burger_round: this.isRound,
      };
    },
  },
};
</script>

<style lang="stylus">
.burger
  display block
  width 2em
  height @width
  background none
  padding 0
  border 0
  outline none
  cursor pointer
  color inherit

  &__svg
    display block
    width 100%
    height 100%
    ~/_round &
      stroke-linejoin round
      stroke-linecap round

  &__line
    fill none
    stroke currentColor
    stroke-width 6
    transition stroke-dasharray 600ms cubic-bezier(0.4, 0, 0.2, 1), stroke-dashoffset 600ms cubic-bezier(0.4, 0, 0.2, 1)
    &_one
      stroke-dasharray 60 207
      ~/_active &
        stroke-dasharray 90 207
        stroke-dashoffset -134
    &_two
      stroke-dasharray 60 60
      ~/_active &
        stroke-dasharray 1 60
        stroke-dashoffset -30
    &_three
      stroke-dasharray 60 207
      ~/_active &
        stroke-dasharray 90 207
        stroke-dashoffset -134
</style>
